<div class="form-container" *ngIf="withdrawalReasonCheck!=='withDraw' && typecheck!=='info'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5">Resignation Intimation Form </div>
      </ion-col>

      <ion-col size="auto" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- authority-form.component.html -->
    <mat-dialog-content class="p-0">
      <form [formGroup]="condidateForm">
        <ion-row>
          <ion-row>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Name<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="employeeName" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee dept<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="department" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Band<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="band" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Grade<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="grade" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee designation<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="designation" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Date of resignation<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="resignationDate" placeholder="type here" style="color:black"
                  readonly />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Status<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="status" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Notice period<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="noticePeriod" placeholder="type here" style="color:black" />
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Last working date<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput [matDatepicker]="picker" formControlName="lastWorkingDate" placeholder="Select date"
                  [min]="todayDate" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="hasError('lastWorkingDate', 'required')">Last working date is required</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">
                Personal Mail ID <span class="red-cl">*</span>
              </div>

              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="personalMailId" placeholder="Enter your personal email" type="email"
                  style="color: black" />
              </mat-form-field>

              <mat-error class="formLabelRegularfs12" *ngIf="condidateForm.get('personalMailId')?.hasError('required')">
                Personal email is required
              </mat-error>
              <mat-error class="formLabelRegularfs12" *ngIf="condidateForm.get('personalMailId')?.hasError('email')">
                Please enter a valid email address
              </mat-error>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Reason for exit<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select formControlName="reasonForExit" placeholder="Select">
                  <mat-option value="Manager Relationship">Manager Relationship</mat-option>
                  <mat-option value="Career Growth">Career Growth</mat-option>
                  <mat-option value="Health">Health</mat-option>
                  <mat-option value="Personal">Personal</mat-option>
                  <mat-option value="Other">Other</mat-option>
                  <!-- Add more options here -->
                </mat-select>
                <mat-error *ngIf="hasError('reasonForExit', 'required')">Reason is required</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Explain in detail the reason for exit<span class="red-cl">*</span>
              </div>

              <textarea class="edittextarea w-100 mat-height40 mat-input-style"
                formControlName="exitExplanation"></textarea>
              <mat-error *ngIf="hasError('exitExplanation', 'required')">Explanation is required</mat-error>
              <mat-error class="formLabelRegularfs12" *ngIf="hasError('exitExplanation', 'maxlength') ">
                Maximum 255 characters allowed
              </mat-error>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Your contact no post your exit<span class="red-cl">*</span></div>


              <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">
                <input type="number" matInput formControlName="contactNumber" placeholder="Enter Mobile Number"
                  (keypress)="handleInput($event, 'contactNumber')" />
              </mat-form-field>
              <mat-error *ngIf="hasError('contactNumber', 'required')">
                mobile number is required.
              </mat-error>
              <mat-error *ngIf="hasError('contactNumber', 'pattern')">
                enter a valid contact number.
              </mat-error>
            </ion-col>


            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Any other reason you don't want manager to know about</div>
              <textarea class="edittextarea w-100 mat-height40 mat-input-style"
                formControlName="hiddenReason"></textarea>
              <mat-error class="formLabelRegularfs12" *ngIf="hasError('hiddenReason', 'maxlength') ">
                Maximum 255 characters allowed
              </mat-error>
            </ion-col>
          </ion-row>


        </ion-row>
        <ion-row>
          <ion-col size class="mt-10">
            <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
            <div class="formLabelSemiBoldfs16 mb-5">Additional Exit Questions</div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" size-md="12" size-lg="12" class="mt-10" *ngFor="let field of quetionsList">
            <div class="formLabelRegularfs16 mb-5">
              {{ field.fieldName }}
            </div>
            <textarea class="edittextarea w-100 mat-height40 mat-input-style" [formControlName]="field.fieldKey"
              placeholder="Enter here" style="padding: 8px 10px;"></textarea>


            <mat-error class="formLabelRegularfs12" *ngIf="condidateForm.get(field.fieldKey)?.hasError('maxlength')">
              Maximum 255 characters allowed
            </mat-error>
          </ion-col>
        </ion-row>


        <ion-row>
          <ion-col size="12" class="text-right mt-10">
            <button type="button" class="add_btn fs-14 fs_12ForMobile " [style.background-color]="buttonColorName"
              [class.disabled]="condidateForm.invalid ||isSubmitting" (click)="saveexitemloyeedata()"
              style="margin: 20px;">Submit
              Resignation</button>
            <button class="back_btn fs-14 fs_12ForMobile " (click)="cancelbutton()">Cancel</button>
          </ion-col>
        </ion-row>
      </form>
    </mat-dialog-content>

  </div>
</div>

<!-- -------------------------------------------------------Widrol-------------------------------------------------------- -->


<div class="form-container" *ngIf="withdrawalReasonCheck==='withDraw'&& typecheck!=='info'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">Withdraw Resignation</div>
      </ion-col>

      <ion-col size="auto" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <mat-dialog-content class="p-0">
      <!-- authority-form.component.html -->
      <form [formGroup]="condidateForm" style="margin: 10px;">
        <ion-row>
          <ion-col size="12" class="mt-10">
            <div class="formLabelRegularfs16 mb-5">Are you sure you want to withdraw your resignation?
              Please provide a reason for withdrawing:<span class="red-cl">*</span>
            </div>
            <textarea rows="3" cols="32" class="edittextareareason w-100 mat-height40 mat-input-style"
              formControlName="withDraw" placeholder="Enter your reason for withdrawing the resignation..."
              maxlength="255" [readonly]="checkdepatment!=='myResigntion'"></textarea>
            <div *ngIf="condidateForm.value.withDraw.length>255" class="red-cl">
              Maximum 255 characters allowed.
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="text-right mt-10">
            <button class="back_btn fs-14 fs_12ForMobile" (click)="cancelbutton()">Cancel</button>

            <button
              *ngIf="(loggedInUserRole && ['hr admin','super admin','md','phi admin'].includes(loggedInUserRole.trim().toLowerCase())) && !checkHRSuperAdminApproval"
              type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
              (click)="saveWithdrawReason(true)" [disabled]="condidateForm.get('withDraw')?.invalid"
              [style.opacity]="condidateForm.get('withDraw')?.invalid ? '0.6' : '1'">
              Approve
            </button>
            <button
              *ngIf="(loggedInUserRole && ['hr admin','super admin','md','phi admin'].includes(loggedInUserRole.trim().toLowerCase())) && !checkHRSuperAdminApproval"
              type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="'red'"
              (click)="saveWithdrawReason(false)" [disabled]="condidateForm.get('withDraw')?.invalid"
              [style.opacity]="condidateForm.get('withDraw')?.invalid ? '0.6' : '1'">
              Reject
            </button>
            <button
              *ngIf="(loggedInUserRole && ['hr admin','super admin','md','phi admin'].includes(loggedInUserRole.trim().toLowerCase())||checkdepatment== 'myResigntion')&& checkHRSuperAdminApproval"
              type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="'green'"
              [disabled]="condidateForm.get('withDraw')?.invalid"
              [style.opacity]="condidateForm.get('withDraw')?.invalid ? '0.6' : '1'">
              Approved
            </button>

            <!-- <button   *ngIf="checkdepatment== 'myResigntion' "
            type="button" 
            class="add_btn fs-14 fs_12ForMobile ml-10"
            [style.background-color]="buttonColorName"
            (click)="saveWithdrawReason()"
            [disabled]="(updateEmployeeData.withdrawalReason !== null || checkdepatment !== 'myResigntion' ||(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') )"
            [style.opacity]="(updateEmployeeData.withdrawalReason !== null|| checkdepatment !== 'myResigntion'||(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD') ) ? '0.6' : '1'"
            >
            Submit
          </button> -->


            <button *ngIf="checkdepatment== 'myResigntion'&& !checkHRSuperAdminApproval" type="button"
              class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
              (click)="saveWithdrawReason(null)"
              [disabled]="condidateForm.get('withDraw')?.invalid || checkdepatment !== 'myResigntion' ||updateEmployeeData.withdrawalReason !== null"
              [style.opacity]="condidateForm.get('withDraw')?.invalid || checkdepatment !== 'myResigntion'||updateEmployeeData.withdrawalReason !== null ? '0.6' : '1'">Send
              For Approval</button>

          </ion-col>
        </ion-row>
      </form>
    </mat-dialog-content>
  </div>
</div>

<div class="form-container" *ngIf="typecheck==='info'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">Additional Exit Questions</div>
      </ion-col>

      <ion-col size="auto" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <mat-dialog-content class="p-0">
      <!-- authority-form.component.html -->
      <!-- <form [formGroup]="condidateForm" style="margin: 10px;">
        <ion-row>
          <ion-col size="12" size-md="6" size-lg="4" class="mt-10" *ngFor="let field of quetionsList">
            <div class="formLabelRegularfs16 mb-5">
              {{ field.fieldName }}
            </div>
            <textarea class="edittextarea w-100 mat-height40 mat-input-style" [formControlName]="field.fieldName"
              placeholder="Enter here" style="padding: 8px 10px;" readonly></textarea>


          </ion-col>
        </ion-row>
      </form> -->
      <form [formGroup]="condidateForm" style="margin: 10px;" *ngIf="condidateForm">
        <ion-row>
          <ion-col size="12" size-md="12" size-lg="12" class="mt-10" *ngFor="let field of quetionsList">
            <div class="formLabelRegularfs16 mb-5">
              {{ field.fieldName }}
            </div>
            <textarea class="edittextarea w-100 mat-height100 mat-input-style" [formControlName]="field.fieldKey"
              placeholder="Enter here" style="padding: 8px 10px;" readonly>
      </textarea>
          </ion-col>
        </ion-row>
      </form>

    </mat-dialog-content>
  </div>
</div>